import React from 'react';
import { mapAbsoluteAssetViewToStyledImg } from './mappers';
import type { WAssetView } from '../mockData/theme_styles/types';

export const renderAbsoluteAssets = (a: WAssetView | undefined) => {
  if (a?.absolute) {
    return a?.absolute.map(({ responsiveStyles, src, altText }) => {
      const Img = mapAbsoluteAssetViewToStyledImg(responsiveStyles);
      return <Img src={src} alt={altText} />;
    });
  }
  return null;
};
